<template>
  <div
    class="gradation"
    @click.stop="handleSquareBtnClick"
  >
    <span class="text" :class="className"> {{text}} </span>
    <img :src="img" v-if="img !== ''">
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: 'SKIP',
    },
    className: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleSquareBtnClick() {
      this.$emit('handleSquareBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.gradation{
  font-size: 24px;
  background-color: $deepColor;
  color: $white;
  border-radius: 6px;
  border: solid 1px $white;
  padding: 10px 20px;
  cursor: pointer;
  transition: 0.4s;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  .text{
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: bold;
  }
  img {
    margin-left: 10px;
    width: 28px;
  }
  .large {
    font-size: 16px;
    font-weight: bold;
  }
  &:hover {
    opacity: 0.6;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .gradation{
    .text{
      font-size: 14px;
    }
    &:hover {
      opacity: 1;
    }
  }
}
</style>
